"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.askAnAgentListAutoComplete = exports.askAnAgentListSearch = void 0;
var Api_1 = require("@/api/remote/Api");
exports.askAnAgentListSearch = function (keyword, page, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/question/getquestions",
        data: {
            searchText: keyword,
            pageNumber: page,
        },
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.askAnAgentListAutoComplete = function (keyword, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/question/getquestionskeywords",
        data: {
            searchText: keyword,
        },
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
